import { render, staticRenderFns } from "./FixturesListWidget.vue?vue&type=template&id=0329ff7a&scoped=true"
import script from "./FixturesListWidget.vue?vue&type=script&lang=js"
export * from "./FixturesListWidget.vue?vue&type=script&lang=js"
import style0 from "./FixturesListWidget.vue?vue&type=style&index=0&id=0329ff7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0329ff7a",
  null
  
)

export default component.exports